module.exports = __webpack_public_path__ + "static/media/arrow-alt-left.9a945acb.svg";